"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _react = _interopRequireDefault(require("react"));
var _stop = _interopRequireDefault(require("cccisd-icons/stop"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner8"));
var _loop = _interopRequireDefault(require("cccisd-icons/loop3"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import ClickButton from 'cccisd-click-button';
var Boilerplate = window.cccisd.boilerplate;
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component(props) {
    var _this;
    _classCallCheck(this, Component);
    _this = _callSuper(this, Component, [props]);
    _defineProperty(_this, "timer", null);
    _defineProperty(_this, "first", true);
    _defineProperty(_this, "state", {
      logs: [],
      ip: false,
      grep: '',
      vgrep: '',
      rows: 100,
      refreshTimer: 2500,
      loading: false,
      autoRefresh: true
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.getLogs();
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.cancelTimer();
    });
    _defineProperty(_this, "toggleRefresh", function () {
      _this.cancelTimer();
      if (!_this.state.autoRefresh) {
        _this.startTimer();
      }
      _this.setState({
        autoRefresh: !_this.state.autoRefresh
      });
    });
    _defineProperty(_this, "changeRows", function (e) {
      _this.setState({
        rows: e.target.value
      }, function () {
        _this.cancelTimer();
        _this.getLogs();
      });
    });
    _defineProperty(_this, "changeInclude", function (e) {
      _this.setState({
        grep: e.target.value
      }, function () {
        _this.cancelTimer();
        _this.getLogs();
      });
    });
    _defineProperty(_this, "changeExclude", function (e) {
      _this.setState({
        vgrep: e.target.value
      }, function () {
        _this.cancelTimer();
        _this.getLogs();
      });
    });
    _defineProperty(_this, "startTimer", function () {
      _this.timer = setTimeout(function () {
        _this.getLogs();
      }, _this.state.refreshTimer);
    });
    _defineProperty(_this, "cancelTimer", function () {
      clearTimeout(_this.timer);
    });
    _defineProperty(_this, "getLogs", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$state, grep, vgrep, rows, autoRefresh, response, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$state = _this.state, grep = _this$state.grep, vgrep = _this$state.vgrep, rows = _this$state.rows, autoRefresh = _this$state.autoRefresh;
            _this.setState({
              loading: true
            });
            _context.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('appdefs.debug.laravel'), {
              params: {
                grep: grep,
                vgrep: vgrep,
                rows: rows
              }
            });
          case 1:
            response = _context.v;
            if (response.data && response.data.data) {
              data = response.data.data;
              _this.setState({
                logs: data.logs,
                ip: data.ip,
                loading: false
              });
              if (autoRefresh) {
                _this.cancelTimer();
                _this.startTimer();
              }
            }
            if (_this.first) {
              _this.refs.logs.scrollTop = 999999999;
              _this.first = false;
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "renderControls", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].controls
      }, _this.renderStatus(), _this.renderRowSetting(), _this.renderFilterSetting());
    });
    _defineProperty(_this, "renderStatus", function () {
      var _this$state2 = _this.state,
        loading = _this$state2.loading,
        autoRefresh = _this$state2.autoRefresh;
      if (loading) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].rotating
        }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], null));
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        onClick: _this.toggleRefresh,
        className: _style["default"].controlButton
      }, autoRefresh ? /*#__PURE__*/_react["default"].createElement(_stop["default"], null) : /*#__PURE__*/_react["default"].createElement(_loop["default"], null));
    });
    _defineProperty(_this, "renderRowSetting", function () {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].controlRows
      }, /*#__PURE__*/_react["default"].createElement("select", {
        onChange: _this.changeRows,
        name: "rows",
        defaultValue: 100
      }, /*#__PURE__*/_react["default"].createElement("option", {
        key: 1,
        value: "1"
      }, "Last 1 row"), /*#__PURE__*/_react["default"].createElement("option", {
        key: 10,
        value: "10"
      }, "Last 10 rows"), /*#__PURE__*/_react["default"].createElement("option", {
        key: 100,
        value: "100"
      }, "Last 100 rows"), /*#__PURE__*/_react["default"].createElement("option", {
        key: 1000,
        value: "1000"
      }, "Last 1000 rows"), /*#__PURE__*/_react["default"].createElement("option", {
        key: -1,
        value: "-1"
      }, "All rows")));
    });
    _defineProperty(_this, "renderFilterSetting", function () {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].controlFilter
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].filter
      }, "Rows must contain:\xA0", /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: "include",
        onChange: _this.changeInclude
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].filter
      }, "Rows must not contain:\xA0", /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: "exclude",
        onChange: _this.changeExclude
      })));
    });
    _defineProperty(_this, "renderLogs", function () {
      var _this$state3 = _this.state,
        ip = _this$state3.ip,
        logs = _this$state3.logs;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ip && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].ip
      }, _this.state.ip), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].logs,
        ref: "logs"
      }, logs.map(function (row, idx) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: idx
        }, _this.formatRow(row));
      })));
    });
    _defineProperty(_this, "formatRow", function (row) {
      var _row$split = row.split(' '),
        _row$split2 = _toArray(_row$split),
        date = _row$split2[0],
        time = _row$split2[1],
        level = _row$split2[2],
        log = _row$split2.slice(3);
      if (date && date.substring(0, 1) === '[' && time && time.substring(time.length - 1, time.length) === ']') {
        var levelParts = level.split('.');
        var levelName = levelParts.length > 1 ? levelParts[1].replace(/:$/, '') : 'NONE';
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].date
        }, date, " ", time), "\xA0", /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].level + ' ' + _style["default"][levelName]
        }, level), "\xA0", /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].logText
        }, log.join(' ')));
      }
      return row;
    });
    _this.toggleRefresh = _this.toggleRefresh.bind(_this);
    _this.changeRows = _this.changeRows.bind(_this);
    _this.changeInclude = _this.changeInclude.bind(_this);
    _this.changeExclude = _this.changeExclude.bind(_this);
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var controls = this.renderControls();
      var logs = this.renderLogs();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper
      }, controls, logs);
    }
  }]);
}(_react["default"].Component);